// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1483":"7d0b7259","5572":"a7595aa1","7823":"7d0b7259"}[chunkId] + ".chunk.css";
};